import { clients } from "../../../lib/axios";
import { AxiosError } from "axios";
import { useMutation, UseMutationOptions, useQueryClient } from "react-query";
import { AttachmentDto } from "../types";
import { AttachmentKeys } from "./attachment.keys";

const updateAttachment = async (id: string, data: FormData) => {
  const axios = await clients();
  return axios.put(`/api/attachments/${id}`, data, { 
    headers: {
      'content-type': 'multipart/form-data'
    } 
  }).then((response) => response.data as AttachmentDto);
};

export interface UpdateAttachmentProps {
  id: string;
  formData: FormData;
}

export function useUpdateAttachment(
  options?: UseMutationOptions<AttachmentDto, AxiosError, UpdateAttachmentProps>
) {
  const queryClient = useQueryClient();

  return useMutation(
    ({ id, formData: updatedAttachment }: UpdateAttachmentProps) =>
      updateAttachment(id, updatedAttachment),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(AttachmentKeys.lists());
        queryClient.invalidateQueries(AttachmentKeys.details());
      },
      ...options,
    }
  );
}
